<select class="form-control dropdown-toggle header-language-selector" [ngClass]="{'colorfur-text-day': selectedOpdType=='general','colorfur-text-prime': selectedOpdType=='prime'}" [disabled]="checkDisabled" [(ngModel)]='selectedOpdType' (change)="changeOpdType($event)">
  @for (opd of care_type; track opd) {
    <option [value]=opd.id [class]="opd.id">{{opd.name}}</option>
  }
</select>